module.exports = __webpack_public_path__ + "img/Feature-5.c325ecc.svg";